<template>
    <section class="section-style text-center bg-white">
        <div class="container-fluid"
             data-aos="fade-right"
             data-aos-offset="50"
             data-aos-once="true"
             data-aos-duration="500">
            <h2 class="bd-title section-title default-letter-spacing text-uppercase font-weight-bold font-md" style="margin-top: 0em;">Marketing</h2>
            <div class="row justify-content-center">
                <div class="col-6 col-sm-6 col-lg-3">
                    <a href="https://branchup.com" target="_blank" class="transi"><img class="icon mb-2 widthcien" src="/assets/crealco/branchup.jpg" alt="Branch Up"/></a>
                </div>

                <div class="col-6 col-sm-6 col-lg-3">
                    <a href="https://www.ultimatejetvacations.com/app/dashboard" class="transi"><img class="icon mb-2 widthcien" src="/assets/crealco/social-media-kit.jpg" alt="Social Media Kit"/></a>
                </div>

                <div class="col-6 col-sm-6 col-lg-3">
                    <a href="https://festiveavailability.ultimatejetvacations.com" target="_blank" class="transi"><img class="icon mb-2 widthcien" src="/assets/crealco/receive-faster-sms.jpg" alt="Receive Faster SMS"/></a>
                </div>

                <div class="col-6 col-sm-6 col-lg-3">
                    <a href="https://blog.ultimatejetvacations.com" target="_blank" class="transi"><img class="icon mb-2 widthcien" src="/assets/crealco/blog.jpg" alt="Blog"/></a>
                </div>

            </div>
        </div>
    </section>
</template>

<script>

    import AOS from 'aos';
    import 'aos/dist/aos.css';

    AOS.init();

    export default {
        mounted() {

        }
    }

</script>

<style lang="scss" type="text/scss">
    .transi {
        transition: .5s ease all !important;
    }
    .transi:hover {
        opacity: .8;
    }
    .widthcien {
        width: 100%;
    }
</style>
